<template>
  <div>
    <v-container fluid>

      <v-snackbar v-model="alert" centered color="success" timeout="800" top>
        <v-icon dark left>mdi-check-circle</v-icon>
        Copié dans le presse-papier.
      </v-snackbar>

      <div class="main">
        <v-row>
          <v-col cols="12">
            <div class="d-flex justify-space-between mb-3">
              <v-spacer/>

              <v-btn class="rounded-lg"
                     color="gifty"
                     dark
                     @click="$refs.createMethodDialog.open()"
                     depressed
              >
                <v-icon left>mdi-plus</v-icon>
                Ajouter une méthode
              </v-btn>
            </div>

            <v-card class="rounded-lg shadow">
              <v-overlay :value="overlay" absolute color="white" opacity="0.5">
                <v-progress-circular
                    color="primary"
                    indeterminate
                    size="50"
                ></v-progress-circular>
              </v-overlay>

              <v-card-title>
                <div>
                  <v-text-field
                      v-model="keyword"
                      append-icon="mdi-magnify"
                      clearable
                      dense
                      filled
                      hide-details
                      placeholder="Rechercher..."
                      rounded
                      single-line

                  />
                </div>
                <v-spacer/>

                <v-btn color="grey"
                       icon
                       @click="getData">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>

              </v-card-title>

              <v-divider/>

              <v-card-text v-if="isLoading">
                <v-skeleton-loader type="table"/>
              </v-card-text>

              <div v-else>
                <v-card-text class="pa-0">
                  <v-data-table :headers="headers"
                                :items="p_methods"
                                :search="keyword"
                  >

                    <template v-slot:item.is_available="{ item }">
                      <v-icon color="success" v-if="item.is_available">mdi-check-circle</v-icon>
                      <v-icon color="red" v-else>mdi-close-circle</v-icon>
                    </template>


                    <template v-slot:item.actions="{ item }">
                      <div class="d-flex">
                        <v-btn icon @click="$refs.createMethodDialog.open(item)">
                          <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <v-btn icon @click="remove(item.id)">
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </div>
                    </template>

                  </v-data-table>
                </v-card-text>

              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <CreateMethodDialog ref="createMethodDialog" :services="services" @refresh="getData"/>

    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import CreateMethodDialog from "./components/CreateMethodDialog.vue";

export default {
  components: {CreateMethodDialog},
  data() {
    return {
      id: '',
      keyword: '',
      overlay: false,
      isLoading: false,
      alert: false,
      services: [],
      p_methods: [],
      headers: [
        {
          text: 'Disponnible',
          value: 'is_available',
        },
        {
          text: 'Nom de méthode',
          value: 'name',
        },
        {
          text: 'Service',
          value: 'service.name',
        },
        {
          text: 'Méthode de récupération',
          value: 'retrieval_method',
        },
        {
          text: 'Récupération du montant',
          value: 'amount_retrieval',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    getData() {
      this.isLoading = true
      HTTP.get('/v1/payings-bill-methods').then(res => {
        this.p_methods = res.data.data
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    getServices() {
      HTTP.get('/v1/payings-bill-methods/services').then(res => {
        this.services = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    remove(id) {
      this.id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.overlay = true;
      HTTP.post("/v1/payings-bill-methods/delete", {
        id: this.id,
      }).then(() => {
        this.overlay = false;
        let i = this.p_methods.findIndex((el) => el.id === this.id);
        this.$delete(this.p_methods, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
  },
  created() {
    this.getData();
    this.getServices();
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    }
  }
};
</script>

<style scoped></style>
